<template>
  <div class="home">
    <Header :isbig="true"></Header>
    <div class="homeBigSwiper">
      <el-carousel trigger="click" height="350px">
        <el-carousel-item v-for="item in homeSwiper.content" :key="item.imgUrl">
          <a href="javaScript:"><img :src="imgURL + item.imgUrl" alt=""/></a>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="section section1">
      <div class="main" style="border: none;padding:0px">
        <threeRecommend :booklist="shelf1.content"></threeRecommend>
      </div>
    </div>
    <div class="section secNav">
      <div class="main">
        <a href="javaScript:" class="active" @click="goPositon('#shelf2')">
          大神推荐
        </a>
        <a href="javaScript:" @click="goPositon('#shelf3')">
          新书榜单
        </a>
        <a href="javaScript:" @click="goPositon('#shelf4')">
          免费推荐
        </a>
        <a href="javaScript:" @click="goPositon('#shelf5')">
          精选推荐
        </a>
      </div>
    </div>
    <!-- 6个 -->
    <div class="section section2" id="shelf2">
      <div class="main">
        <h3>- 大神推荐 -</h3>
        <sixRecommend :big="true" :booklist="shelf2.content"></sixRecommend>
      </div>
    </div>
    <!-- 榜单 -->
    <div class="section section3" id="shelf3">
      <div class="main clearfix line">
        <div class="rankl">
          <h3>新书榜</h3>
          <ol data-collect-id="112">
            <li v-for="(book, index) in shelf3" :key="index">
              <div>
                <em class="num">{{ index + 1 }}.</em>
                <dl>
                  <dt>
                    <a href="javaScript:" @click="goSeeDetail(book.id)">
                      <img v-lazy="imgURL + book.iconUrl" :alt="book.name" />
                    </a>
                  </dt>
                  <dd>
                    <a
                      data-collect-index="1"
                      href="javaScript:"
                      @click="goSeeDetail(book.id)"
                    >
                      <h3 :title="book.name">{{ book.name }}</h3>
                    </a>
                    <p
                      class="flex clearfix"
                      style="display: flex;align-items: center;height: 20px"
                    >
                      <a
                        style="display: inline-block;max-width: 112px;height: 20px;overflow: hidden;"
                        @click="goSeeDetail(book.id)"
                        class="name fl"
                        ><em
                          style="display:inline-block;height: 20px;overflow: hidden"
                          class="ellipsis"
                          v-if="book.author != undefined"
                          >{{ book.author.name }}</em
                        ></a
                      ><em
                        style="color: #999;height: 20px;line-height:25px"
                        class="fl"
                        >/</em
                      ><a
                        @click="goSeeDetail(book.id)"
                        class="name fl"
                        target="_blank"
                        ><em style="height: 20px;overflow: hidden;">{{
                          book.sort
                        }}</em></a
                      >
                    </p>
                  </dd>
                </dl>
              </div>
            </li>
          </ol>
        </div>
        <div class="rankl">
          <h3>潜力榜</h3>
          <ol>
            <li v-for="(book, index) in shelf4" :key="index">
              <div>
                <em class="num">{{ index + 1 }}.</em>
                <dl>
                  <dt>
                    <a href="javaScript:" @click="goSeeDetail(book.id)">
                      <img v-lazy="imgURL + book.iconUrl" :alt="book.name" />
                    </a>
                  </dt>
                  <dd>
                    <a
                      data-collect-index="1"
                      href="javaScript:"
                      @click="goSeeDetail(book.id)"
                    >
                      <h3 :title="book.name">{{ book.name }}</h3>
                    </a>
                    <p
                      class="flex clearfix"
                      style="display: flex;align-items: center;height: 20px"
                    >
                      <a
                        style="display: inline-block;max-width: 112px;height: 20px;overflow: hidden;"
                        @click="goSeeDetail(book.id)"
                        class="name fl"
                        target="_blank"
                        ><em
                          style="display:inline-block;line-height: 20px;overflow: hidden"
                          v-if="book.author != undefined"
                          >{{ book.author.name }}</em
                        ></a
                      ><em
                        class="fl"
                        style="display: inline-block;color: #999;line-height:25px"
                        >/</em
                      ><a
                        @click="goSeeDetail(book.id)"
                        class="name fl"
                        target="_blank"
                        ><em style="height: 20px;overflow: hidden;">{{
                          book.sort
                        }}</em></a
                      >
                    </p>
                  </dd>
                </dl>
              </div>
            </li>
          </ol>
        </div>
        <div class="rankl">
          <h3>英雄榜</h3>
          <ol>
            <li v-for="(book, index) in shelf5" :key="index">
              <div>
                <em class="num">{{ index + 1 }}.</em>
                <dl>
                  <dt>
                    <a href="javaScript:" @click="goSeeDetail(book.id)">
                      <img v-lazy="imgURL + book.iconUrl" :alt="book.name" />
                    </a>
                  </dt>
                  <dd>
                    <a
                      data-collect-index="1"
                      href="javaScript:"
                      @click="goSeeDetail(book.id)"
                    >
                      <h3 :title="book.name">{{ book.name }}</h3>
                    </a>
                    <p
                      class="flex clearfix"
                      style="display: flex;align-items: center;height: 20px"
                    >
                      <a
                        style="display: inline-block;max-width: 112px;height: 20px;overflow: hidden;"
                        @click="goSeeDetail(book.id)"
                        class="name fl"
                        target="_blank"
                        ><em
                          style="display:inline-block;height: 20px;overflow: hidden"
                          v-if="book.author != undefined"
                          >{{ book.author.name }}</em
                        ></a
                      ><em
                        class="fl"
                        style="display: inline-block;color: #999;height: 20px;line-height:25px"
                        >/</em
                      ><a
                        @click="goSeeDetail(book.id)"
                        class="name fl"
                        target="_blank"
                        ><em style="height: 20px;overflow: hidden;">{{
                          book.sort
                        }}</em></a
                      >
                    </p>
                  </dd>
                </dl>
              </div>
            </li>
          </ol>
        </div>
        <!-- <div class="rankl">
            <h3>土豪榜</h3>
            <ol data-collect-id="112">
              <li v-for="(book, index) in 5" :key="index">
                <div>
                  <em class="num">{{ index + 1 }}.</em>
                  <dl>
                    <dt>
                      <a
                        data-collect-index="1"
                        href="https://www.heiyan.com/book/128615"
                        target="_blank"
                      >
                        <img
                          src="https://b.heiyanimg.com/book/128615.jpg@!bs?2"
                          alt="第一战神"
                        />
                      </a>
                    </dt>
                    <dd>
                      <a
                        data-collect-index="1"
                        href="https://www.heiyan.com/book/128615"
                        data-id="128615"
                        target="_blank"
                      >
                        <h3 title="第一战神">第一战神</h3>
                      </a>
                    </dd>
                  </dl>
                </div>
              </li>
            </ol>
          </div> -->
        <div class="rankr" id="ranktab">
          <h3>
            <span :class="{ cur: curIndex == 0 }" @click="chooseCur(0)"
              >新书钻石榜</span
            >
            <span :class="{ cur: curIndex == 1 }" @click="chooseCur(1)"
              >总钻石榜</span
            >
          </h3>
          <div class="rcon">
            <div class="rinner" ref="rinner" style="margin-left: 0px;">
              <ol>
                <li v-for="(book, index) in shelf6" :key="index">
                  <a @click="goSeeDetail(book.id)">
                    <em>{{ index + 1 }}.</em>
                    <b :title="book.name">{{ book.name }}</b>
                    <span>{{ book.words }}字</span>
                  </a>
                </li>
              </ol>
              <ol>
                <ol>
                  <li v-for="(book, index) in shelf7" :key="index">
                    <a @click="goSeeDetail(book.id)">
                      <em>{{ index + 1 }}.</em>
                      <b :title="book.name">{{ book.name }}</b>
                      <span>{{ book.words }}字</span>
                    </a>
                  </li>
                </ol>
              </ol>
            </div>
          </div>
          <!-- end of rcon -->
        </div>
      </div>
    </div>
    <!-- 两列3个 -->
    <div class="section section4" id="shelf4">
      <div class="main">
        <h3>- 免费推荐 -</h3>
        <threeRecommend :booklist="shelf8.content"></threeRecommend>
      </div>
    </div>
    <!-- 简略6个 -->
    <div class="section section5" id="shelf5">
      <div class="main">
        <h3>- 精选推荐 -</h3>
        <simpleRecommend
          :big="true"
          :booklist="shelf9.content"
        ></simpleRecommend>
      </div>
    </div>
    <Footer :big="true"></Footer>
  </div>
</template>

<script>
import { getBookList, homeshelf } from "@/api/book";
export default {
  name: "home",
  data() {
    return {
      homeBigSwiper: [
        "https://b.heiyanimg.com/img/1567133673969_163828188.png",
        "https://b.heiyanimg.com/img/1566270372124_1721523900.jpg",
        "https://b.heiyanimg.com/img/1567133648313_1126296998.png"
      ],
      booklist: [], //书的列表
      shelfBookList: [], //书的列表
      curIndex: 0,
      shelf1: [],
      shelf2: [],
      shelf3: [],
      shelf4: [],
      shelf5: [],
      shelf6: [],
      shelf7: [],
      shelf8: [],
      shelf9: [],
      homeSwiper: {}
    };
  },
  created() {
    this.$nextTick(() => {
      this.bookShelf();
      this.getIdShelf();
    });
  },
  methods: {
    // 去书籍详情
    goDetail(id) {
      this.$router.push(`/bookDetail/${id}`);
    },
    // 切换榜单
    chooseCur(index) {
      this.curIndex = index;
      this.$refs["rinner"].style.marginLeft = -270 * index + "px";
    },
    // 书架列表
    async bookShelf() {
      // let params = { pageNo: 1, pageSize: 59 }
      let list = await getBookList({ pageNo: 1, pageSize: 59 });
      if (list.success) {
        this.shelfBookList = list.data.items;
        this.shelfBookList.forEach(item => {
          item.introduce = item.introduce.substring(0, 40) + "...";
        });
        // this.shelf1 = this.shelfBookList.splice(0, 6);
        /*  this.shelf2 = this.shelfBookList.splice(0, 6); */
        this.shelf3 = this.shelfBookList.splice(0, 5);
        this.shelf4 = this.shelfBookList.splice(0, 5);
        this.shelf5 = this.shelfBookList.splice(0, 5);
        this.shelf6 = this.shelfBookList.splice(0, 10);
        this.shelf7 = this.shelfBookList.splice(0, 10);
        // this.shelf8 = this.shelfBookList.splice(0, 6);
        // this.shelf9 = this.shelfBookList.splice(0, 6);
      }
    },
    getIdShelf() {
      homeshelf().then(res => {
        if (res.success) {
          this.allShelfList = res.data.shelves;
          this.allShelfList.forEach(item => {
            if (item.id !== "yuanshi_web_carousel") {
              item.content.forEach(items => {
                items.book.introduce =
                  items.book.introduce.substring(0, 40) + "...";
              });
            }

            if (item.id == "yuanshi_web_carousel") {
              this.homeSwiper = item;
            } else if (item.id == "yuanshi_web_recommend") {
              this.shelf1 = item;
            } else if (item.id == "yuanshi_web_dashen_recom") {
              this.shelf2 = item;
            } else if (item.id == "yuanshi_web_free_recom") {
              this.shelf8 = item;
            } else if (item.id == "yuanshi_web_select_recom") {
              this.shelf9 = item;
            }
          });
        }
      });
    },
    updated() {
      document.querySelector("#shelf3").scrollIntoView(true);
    },
    goSeeDetail(bookid) {
      this.$router.push(`/bookdetail/${bookid}`);
    },
    goPositon(id) {
      let h = $(id).offset();
      $("html,body").animate({ scrollTop: h.top - 30 }, 200);
    }
  }
};
</script>
<style>
.el-carousel {
  overflow-x: inherit;
}
.el-carousel__button {
  background: #fff;
  display: block;
  width: 8px;
  height: 8px;
  outline: 0;
  border-radius: 4px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.is-active .el-carousel__button {
  width: 18px;
  background: #48a2df;
}
</style>

<style lang="stylus" scoped>
.home
    width 100%
    background #fff
    position relative
    .waitimg
        position absolute
        top 125px
        height 800px
        width 1100px
        left 0
        right 0
        margin 0 auto
    .homeBigSwiper
        width 100%
        height: 350px;
        .el-carousel
            width 100%
            min-width 1200px
            img
                width 100%
                height: 350px;
                min-width 1200px
    .secNav
        background rgba(249, 249, 249, 1)
        height 58px
        line-height 58px
        margin-bottom 18px
        a
            color #333333
            font-size 16px
            margin-right 310px
            &:last-child
                margin-right 0
            &.active
                color #48A2DF
            &:hover
                color #48A2DF
    .section
        &.section
            .main
                .rankl
                    float left
                    width 264px
                    margin-right 45px
                    h3
                        height 64px
                        line-height 64px
                        font-size 24px
                        font-weight 400
                        text-align left
                        padding 0px
                        margin-top 0
                    ol
                        li
                            height 110px
                            border-bottom 1px dashed #e5e5e5
                            &:hover
                                dt
                                    -webkit-transform scale(1.1)
                                    transform scale(1.1)
                                a
                                    dd
                                        h3
                                            color #E37300
                                            height auto
                                            &:hover
                                                color #48A2DF
                                        span
                                            color #707070
                            div
                                display block
                                padding 20px 0 0 40px
                                position relative
                                font-weight 400
                                .num
                                    position absolute
                                    left 0
                                    top 20px
                                    font-size 24px
                                    font-weight 500
                                    display block
                                    line-height normal
                                    font-style italic
                                dt
                                    float left
                                    margin-right 20px
                                    width 50px
                                    -webkit-transition all 0.17s ease-in-out
                                    transition all 0.17s ease-in-out
                                    -webkit-transform translateZ(0)
                                    transform translateZ(0)
                                    img
                                        width 50px
                                        height 70px
                                        box-shadow 1px 5px 5px rgba(0, 0, 0, 0.35)
                                dd
                                    padding-top 13px
                                    .flex
                                        a
                                            color #999
                                            &:hover
                                                color #707070
                                    h3
                                        font-size 16px
                                        text-overflow ellipsis
                                        white-space nowrap
                                        overflow hidden
                                        margin-bottom 6px
                                        line-height normal
                                        font-weight 400
                                        height auto
                                        &:hover
                                            color #48A2DF
                                    span
                                        font-size 14px
                                        color #999
                .rankr
                    float left
                    width 270px
                    h3
                        height 64px
                        line-height 64px
                        font-weight 400
                        margin-top 0
                        cursor pointer
                        span
                            font-size 18px
                            color #999
                            -webkit-transition all 0.17s ease-in-out
                            transition all 0.17s ease-in-out
                            -webkit-transform translateZ(0)
                            transform translateZ(0)
                            margin-right 12px
                            &.cur
                                font-size 24px
                                color #333
                    .rcon
                        width 270px
                        overflow hidden
                        font-weight 400
                        height 550px
                        .rinner
                            width 810px
                            height 550px
                            -webkit-transition all ease-in-out 0.2s
                            transition all ease-in-out 0.2s
                            ol
                                float left
                                width 270px
                                padding-top 20px
                                li
                                    height 36px
                                    line-height 32px
                                    margin-bottom 20px
                                    font-weight 400
                                    a
                                        display block
                                        height 36px
                                        position relative
                                        padding 0 80px 0 36px
                                        font-weight 400
                                        &:hover
                                            color #48A2DF
                                            span
                                                color #707070
                                        em
                                            font-style italic
                                            font-weight 500
                                            font-size 18px
                                            position absolute
                                            width 36px
                                            left 0
                                            top 0
                                        b
                                            font-size 16px
                                            font-weight 400
                                        span
                                            text-overflow ellipsis
                                            white-space nowrap
                                            overflow hidden
                                            text-align right
                                            font-size 13px
                                            color #999
                                            position absolute
                                            right 0
                                            top 0
                                        h3
                                            padding 0
</style>
